export default __webpack_public_path__ + "static/background_yellow.a4a9e050f601b4f0e9cbbd9ddfa472b1.png";